const Periods = [
	{ id: 1, name: "День", timestamp: 86400 },
	{ id: 2, name: "Неделя", timestamp: 604800 },
	{ id: 3, name: "Месяц", timestamp: 2592000 },
];

export default Periods;
